/* Capa de red de Boston IA — portada VERBATIM desde boston_ia/index.html.
   apiFetch pega al backend Sabre de Boston (x-api-key + token de sesion del Workspace).
   phpBase() queda legacy para funcionalidades pendientes fuera de esta fase. */

import { state, emit } from './store'

/** Legacy: base historica del backend PHP. Evitar nuevos usos runtime. */
export function phpBase() {
  throw new Error('phpBase() es legacy: la publicacion remota por PHP queda pendiente para una fase posterior.')
}

/** Llamada generica a las APIs Sabre del backend Boston (logica original). */
export async function apiFetch(method, path, body) {
  const base = state.config.bostonApi.replace(/\/$/, '')
  const url = base + (path.startsWith('/') ? path : '/' + path)
  // Headers correctos para las APIs Sabre del backend Boston:
  //   - token: ATH:SHARED/... del Workspace (de la token bar superior)
  //   - x-api-key: clave de agencia
  const headers = {
    'Content-Type': 'application/json',
    'x-api-key': state.config.bostonAkey,
  }
  if (state.sessionToken) headers['token'] = state.sessionToken
  const init = { method, headers }
  if (body !== undefined) init.body = typeof body === 'string' ? body : JSON.stringify(body)
  const t0 = Date.now()
  try {
    const resp = await fetch(url, init)
    const text = await resp.text()
    let parsed
    try {
      parsed = JSON.parse(text)
    } catch {
      parsed = text
    }
    const entry = {
      time: new Date().toISOString(),
      method,
      url,
      status: resp.status,
      ok: resp.ok,
      ms: Date.now() - t0,
      response: parsed,
    }
    state.apisLog.unshift(entry)
    state.apisLog = state.apisLog.slice(0, 50)
    emit()
    return entry
  } catch (err) {
    const entry = {
      time: new Date().toISOString(),
      method,
      url,
      status: 0,
      ok: false,
      ms: Date.now() - t0,
      response: `ERROR red: ${err.message}`,
    }
    state.apisLog.unshift(entry)
    emit()
    return entry
  }
}
